import { m } from 'motion/react';
import styled from 'styled-components';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';

const HeroContainer = styled.section<{ $image: string; $mobileImage: string }>`
  background-image: ${({ $image }) => `url(${$image})`};
  @media (max-width: 768px) {
    background-image: ${({ $mobileImage }) => `url(${$mobileImage})`};
  }
  background-color: #fafafa;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: #fff;
  display: flex;
  width: 100%;
  height: 45vw;
  max-height: 600px;

  @media (max-width: 768px) {
    height: auto;
  }

  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 1rem;
    padding-bottom: 60px;
    max-width: 940px;
    margin: 0 auto;

    @media (max-width: 940px) {
      padding: 300px 32px 48px 32px;
    }
  }
`;

interface Props {
  image: string;
  mobileImage?: string;
  subtitle: string;
  title: string;
  source?: string;
}

const Hero = ({ image, subtitle, title, source, mobileImage = '' }: Props) => {
  return (
    <HeroContainer
      className="hero"
      $image={image}
      $mobileImage={mobileImage ?? image}
    >
      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        variants={containerVariants}
        className="hero-content"
      >
        <m.h1 variants={itemVariants} className="billboard dynamic">
          {title}
        </m.h1>
        <m.p variants={itemVariants}>
          {subtitle}
          <br />
          {source ? <span>{source}</span> : null}
        </m.p>
      </m.div>
    </HeroContainer>
  );
};

export default Hero;
